export const adminParametry = {
  MINIMALNA_WARTOSC_ROSZCZENIA: 'MINIMALNA_WARTOSC_ROSZCZENIA',
  PARAMETR_ZGLOSZENIE_URL_KEY: 'PARAMETR_ZGLOSZENIE_URL',
  PARAMETR_PAK_URL_KEY: 'PARAMETR_PAK_URL',
  PARAMETR_KN_URL_KEY: 'PARAMETR_KN_URL',
  PARAMETR_CC_URL_KEY: 'PARAMETR_CC_URL'
}
